var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('font-awesome-icon',_vm._b({},'font-awesome-icon',Object.assign({}, _vm.$props, _vm.$attrs),false))}
var staticRenderFns = []

export { render, staticRenderFns }